<section class="h-screen flex flex-col">
  
  <!-- Contenedor de la tabla con scroll dinámico -->
  <div class="overflow-auto" style="height: calc(100vh - 200px)">
    <table class="w-full border-collapse">
      <thead class="sticky top-0 bg-white z-30">
        <tr>
          <th class="p-2 border-b sticky left-0 bg-white z-30 min-w-[60px] w-100">
            <div class="flex items-center justify-start">
              <app-button-datepicker [initialDate]="selectedDate" (dateChange)="onDateSelected($event)"></app-button-datepicker>

              <!-- Pinned trips config button -->
              <button mat-icon-button (click)="onOpenPinnedModal()"
                      [matTooltip]="'Configurar viajes pineados (' + pinnedTripIds.size + ' pineados)'"
                      class="ml-2 pin-header-button">
                <div class="relative">
                  <mat-icon [style.color]="pinnedTripIds.size > 0 ? '#f59e0b' : '#6b7280'"
                            [style.transform]="showOnlyPinned ? 'rotate(45deg)' : 'none'">
                    push_pin
                  </mat-icon>
                  <span *ngIf="pinnedTripIds.size > 0" class="pin-counter">{{ pinnedTripIds.size }}</span>
                </div>
              </button>
            </div>
          </th>
          <th *ngFor="let time of timeSlots" class="p-2 border-b min-w-[60px] w-26 text-primary-500">
            <div class="p-0 rounded-lg border border-primary-300"
              [ngClass]="{ 'bg-primary-100': time === selectedHour() }">
              {{ time }}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let route of routes">
          <tr class="group" [ngClass]="{'bg-gray-100': isExpanded[route.id_viaje]}">
            <td
              class="p-2 border-b sticky left-0 z-20 cursor-pointer max-w-26  group-hover:bg-gray-100"
              [ngClass]="{
                'bg-gray-100': isExpanded[route.id_viaje],
                'bg-white': !isExpanded[route.id_viaje]
                }"
                (click)="toggleExpand(route.id_viaje, route)">
              <div class="flex items-center">
                <span class="mr-2">
                  <i class="fas" [ngClass]="{'fa-chevron-down': !isExpanded[route.id_viaje], 'fa-chevron-up': isExpanded[route.id_viaje]}"></i>
                </span>
                <div class="flex flex-row items-center ml-2 gap-1">
                  <mat-icon
                    svgIcon="heroicons_solid:truck"
                    [ngClass]="{
                      'text-green-700': route.statusTripId === 4,
                      'text-yellow-700': route.statusTripId === 2,
                      'text-gray-500': route.statusTripId === 5
                    }"
                    class="mr-1 w-4 h-4">
                  </mat-icon>
                  <!-- Trip Status Icon -->
                  <mat-icon
                    [ngClass]="{
                      'text-green-700': route.statusTripId === 4,
                      'text-yellow-700': route.statusTripId === 2,
                      'text-gray-500': route.statusTripId === 5
                    }"
                    class="mr-1 w-4 h-4"
                    [matTooltip]="route.statusTripId === 4 ? 'Abierto' : route.statusTripId === 5 ? 'Cerrado' : 'En Espera'">
                    <ng-container *ngIf="route.statusTripId === 4">lock_open</ng-container>
                    <ng-container *ngIf="route.statusTripId === 5">lock</ng-container>
                    <ng-container *ngIf="route.statusTripId === 2">hourglass_empty</ng-container>
                  </mat-icon>
                  <!-- Individual Pin Button -->
                  <button mat-icon-button
                          (click)="onTogglePinTrip(route.id_viaje); $event.stopPropagation()"
                          [matTooltip]="isPinnedTrip(route.id_viaje) ? 'Despinear viaje' : 'Pinear viaje'"
                          class="pin-button-compact mr-1">
                    <mat-icon [style.color]="isPinnedTrip(route.id_viaje) ? '#f59e0b' : '#9ca3af'"
                              [style.transform]="isPinnedTrip(route.id_viaje) ? 'rotate(45deg)' : 'none'"
                              class="w-4 h-4">
                      push_pin
                    </mat-icon>
                  </button>
                  <div class="flex flex-col">
                    <h3 class="font-bold text-sm">[{{route.id_viaje}}]-{{ route.code }}</h3>
                    <p class="font-light text-gray-500 text-ellipsis">{{ route.name }}</p>
                  </div>
                </div>                
              </div>
            </td>
            <td *ngFor="let time of timeSlots; let i = index" class="border-b relative z-10">
              <div class="flex items-center">
                @if (i == 0) {
                  <div class="cell-circle-start"></div>
                }
                <div class="cell-line"></div>
                <div (mouseenter)="onHoverActivityDay(time, i)"
                    (mouseleave)="onLeaveActivityDay(time, i)"
                    *ngIf="route?.visits_2?.includes(i)"
                    class="cursor-pointer min-w-8 w-8 h-7 border border-primary-400 rounded-md flex justify-center items-center hover:bg-primary-200 hover:border-primary-500">
                  <div class="font-bold text-primary-500">
                    {{ route.randomNumber[convertTimeToHour(time)] }}
                  </div>
                </div>
                <div class="cell-line"></div>
                @if (i == timeSlots.length - 1) {
                  <div class="cell-circle-end"></div>
                }
              </div>
            </td>
          </tr>
          <tr *ngIf="isExpanded[route.id_viaje]" [@expandCollapse]>
            <td [attr.colspan]="timeSlots.length + 1" class="p-4 bg-gray-50">
              <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4"> -->
                <mat-tab-group style="padding: 0;">
                  <!-- Primer Tab con la primera tabla -->
                  <mat-tab label="Datos del Transporte">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                    
                      <!-- Contenedor del mapa -->
                      <div class="map-container relative h-96 flex overflow-auto sticky top-0" *ngIf="showMap">
                        <!-- Botón siempre visible en el lado derecho -->
                        <button (click)="toggleMapVisibility()" 
                        matTooltip="Ocultar mapa" 
                        class="map-popup-button">
                          <mat-icon svgIcon="heroicons_outline:chevron-left"></mat-icon>
                        </button>
                  
                        <!-- Componente del mapa -->
                        <app-agenda-map [visits]="selectedVisits" class="flex-grow w-full h-full sticky top-0"></app-agenda-map>
                      </div>
                  
                      <!-- Contenedor de los datos del transporte (se reacomodará cuando el mapa se oculte) -->
                      <div   [ngClass]="{
                        'col-span-1': showMap, 
                        'col-span-2': !showMap, 
                        'overflow-y-auto h-[calc(100vh-200px)]': showMap
                      }"  class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                        <button *ngIf="!showMap"
                         (click)="toggleMapVisibility()"
                          class="map-toggle-button"
                          matTooltip="Mostrar mapa" 
                          >
                          <mat-icon color="primary" svgIcon="heroicons_solid:map"></mat-icon>
                        </button>               
                        
                        <p class="flex justify-between items-center mb-8">
                            <span class="font-semibold">Viaje:</span>
                            <span class="flex flex-row">
                              <button class="ml-2 mr-2" (click)="onEditTrip(route)">
                                <mat-icon color="primary" *ngIf="!isUserVisible"  svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                <mat-icon color="primary" *ngIf="isUserVisible" svgIcon="heroicons_outline:check-circle"></mat-icon>
                              </button>
                              <!-- Pin/Unpin trip button -->
                              <button class="ml-2 mr-2" (click)="onTogglePinTrip(route.id_viaje)"
                                      [matTooltip]="isPinnedTrip(route.id_viaje) ? 'Despinear viaje' : 'Pinear viaje'">
                                <mat-icon [style.color]="isPinnedTrip(route.id_viaje) ? '#f59e0b' : '#9ca3af'"
                                          [style.transform]="isPinnedTrip(route.id_viaje) ? 'rotate(45deg)' : 'none'">
                                  push_pin
                                </mat-icon>
                              </button>
                              <span class="flex flex-col">
                                <span class="flex flex-row">
                                <span>{{ route?.id_viaje }}</span>
                                <span [ngClass]="{
                                  'text-gray-500': route?.statusTripId === 5,
                                  'text-green-700': route?.statusTripId === 4,
                                  'text-yellow-700': route?.statusTripId === 2
                                }" class="ml-2">
                                  <!-- Aquí puedes cambiar el texto según el status -->
                                  <span *ngIf="route?.statusTripId === 4">Abierto</span>
                                  <span *ngIf="route?.statusTripId === 5">Cerrado</span>
                                  <span *ngIf="route?.statusTripId === 2">En Espera</span>
                                </span>
                              </span>
                              <!-- Aquí mostramos el formulario de vehículos solo si isFieldVisible es true -->
                                <ng-container *ngIf="isUserVisible; else showUser">
                                  <mat-form-field class="flex-grow w-full">
                                    <input type="text" placeholder="Selecciona usuario" aria-label="Selecciona usuario" matInput
                                      [formControl]="UserToControl" [matAutocomplete]="user">
                                    <mat-autocomplete #user="matAutocomplete" [displayWith]="fetchUserToName">
                                      <mat-option *ngFor="let user of userMasterList; trackBy: trackShipTo" [value]="user._id" class="text-content">
                                        <b class="table-text-code"></b>
                                        <br>
                                        {{ user.user_login_username }}
                                      </mat-option>
                                    </mat-autocomplete>
                                    <mat-error *ngIf="UserToControl.hasError('required')">
                                      Este campo es obligatorio.
                                    </mat-error>
                                  </mat-form-field>
                                </ng-container>
                                <ng-template #showUser>
                                  <span>{{ route?.user }}</span>
                                </ng-template>
                                </span>
                                </span>
                                </p>
                          <p class="flex justify-between items-center">
                            <span class="font-semibold mr-2">Transportista:</span>
                            <span class="flex flex-row">
                            <button *ngIf="route?.ride" class="ml-2 mr-2">
                              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                            </button>
                            <span class="flex flex-col">
                              <span>{{ route?.ride?.externalKeys?.code || '---' }}</span>
                              <span>{{ route?.ride?.name || '---' }}</span>
                            </span>
                            </span>
                          </p>
                        </div>
                  
                        <div>
                          <p class="flex items-center mb-6 w-full justify-between">  
                            <span class="font-semibold mr-2">Responsable:</span>
                            <span class="flex flex-row w-full justify-end"> 
                              <!-- <button *ngIf="route?.responsible" class="ml-2 mr-2" (click)="onButtonClick()">
                                <mat-icon color="primary" svgIcon="heroicons_outline:pencil-square"></mat-icon>
                              </button> -->
                          
                              <!-- <ng-container *ngIf="isFieldVisible; else showText">
                                <mat-form-field class="flex-grow w-full">
                                  <input type="text" placeholder="Selecciona responsable" aria-label="Selecciona responsable" matInput
                                    [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
                                  <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchShipToName" (optionSelected)="onShipToChange()">
                                    @for (shipTo of shipToList; track shipTo) {
                                    <mat-option [value]="shipTo._id" class="text-content">
                                      {{shipTo?.externalKeys?.code + ' - '}}{{ shipTo.name }}
                                    </mat-option>
                                    }
                                  </mat-autocomplete>
                                  <mat-error *ngIf="shipToControl.hasError('required')">
                                      Este campo es obligatorio.
                                  </mat-error>
                              </mat-form-field> -->
                                <!-- <mat-form-field class="flex-grow w-full"> 
                                  <input 
                                    type="text" 
                                    [(ngModel)]="responsableName"
                                    matInput
                                    (ngModelChange)="onResponsableChange()"
                                  />
                                </mat-form-field> -->
                              <!-- </ng-container> -->
                          
                              <!-- Bloque alternativo, se muestra cuando isFieldVisible es false -->
                                <span class="flex flex-col">
                                  <span class="table-text-code">{{ route?.responsible?.externalKeys?.code || '---' }}</span>
                                  <span>{{ route?.responsible?.name || '---' }}</span>
                                </span>
                            </span>
                          </p>
                          
                          
                          <!-- <p class="flex justify-between items-center mb-6">
                            <span class="font-semibold mr-2">Responsable:</span>
                            <span class="flex flex-row">
                            <button *ngIf="route?.responsible" class="ml-2 mr-2" (click)="onButtonClick()">
                              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                            </button>
                            <span class="flex flex-col">
                              <span>{{ route?.responsible?.externalKeys?.code || '---' }}</span>
                              <span>{{ route?.responsible?.name || '---' }}</span>
                            </span>
                          </span>
                          </p> -->
                          
                          <!-- <p class="flex justify-between items-center">
                            <span class="font-semibold mr-2">Vehículo:</span>
                            <span class="flex flex-row">
                            <button *ngIf="route?.vehicle" class="ml-2 mr-2">
                              <mat-icon svgIcon="heroicons_outline:pencil-square"></mat-icon>
                            </button>
                            <span class="flex flex-col">
                              <span>{{ route?.vehicle?.plate || '---' }}</span>
                              <span>{{ route?.vehicle?.name || '---' }}</span>
                            </span>
                          </span>
                          </p> -->
                          <p class="flex items-center mb-6 w-full justify-between">  
                            <span class="font-semibold mr-2">Vehículo:</span>
                            <span class="flex flex-row w-full justify-end"> 
                              <button  class="ml-2 mr-2" (click)="onButtonClick(route.id, route)">
                                <mat-icon color="primary"  *ngIf="!isFieldVisible" svgIcon="heroicons_outline:pencil-square"></mat-icon>
                                <mat-icon color="primary" *ngIf="isFieldVisible" svgIcon="heroicons_outline:check-circle"></mat-icon>
                              </button>
                          
                              <ng-container *ngIf="isFieldVisible; else vehicle">
                                <mat-form-field class="flex-grow w-full">
                                  <input type="text" placeholder="Selecciona vehiculo" aria-label="Selecciona vehiculo" matInput
                                    [formControl]="shipToControl" [matAutocomplete]="autoShipTo">
                                  <mat-autocomplete #autoShipTo="matAutocomplete" [displayWith]="fetchVehicleToName">
                                    @for (shipTo of vehicleList; track shipTo) {
                                    <mat-option [value]="shipTo._id" class="text-content">
                                      <b class="table-text-code">{{shipTo?.plate}}</b>
                                      <br>
                                      {{ shipTo.name }}
                                    </mat-option>
                                    }
                                  </mat-autocomplete>
                                  <mat-error *ngIf="shipToControl.hasError('required')">
                                      Este campo es obligatorio.
                                  </mat-error>
                              </mat-form-field>
                              </ng-container>
                          
                              <ng-template #vehicle>
                                <span class="flex flex-col">
                                  <span class="table-text-code">{{ route?.vehicle?.plate || '---' }}</span>
                                  <span>{{ route?.vehicle?.name || '---' }}</span>
                                </span>
                              </ng-template>
                            </span>
                          </p>
                          
                        </div>
                  
                        <!-- Información del viaje -->
                        <div class="col-span-2 mb-0">
                          <p class="font-semibold">Información del viaje</p>
                        </div>
                  
                        <div>
                          <p class="flex justify-between mb-6">
                            <span class="font-semibold flex items-center">
                              <mat-icon svgIcon="heroicons_outline:flag" class="mr-2" />
                              Inicio:
                            </span> 
                            <span class="flex flex-col">
                              <span>T: {{ route.dateHourStartTeoric | date: 'dd/MM/yyyy HH:mm' }}</span>
                              <span>R: {{ route.dateHourStart | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </span>
                          </p>
                          <p class="flex justify-between mb-6">
                            <span class="font-semibold flex items-center">
                              <mat-icon svgIcon="heroicons_solid:clock" class="mr-2" />
                              Tiempo de Trabajo:
                            </span>
                            <span>{{ route.timeDifference }}</span>
                          </p>
                        </div>
                  
                        <div>
                          <p class="flex justify-between mb-6">
                            <span class="font-semibold flex items-center">
                              <mat-icon svgIcon="heroicons_solid:flag" class="mr-2" />
                              Fin:
                            </span>
                            <span class="flex flex-col">
                            <span>T: {{ route.dateHourEndTeoric | date: 'dd/MM/yyyy HH:mm' }}</span>
                            <span>R: {{ route.dateHourEnd | date: 'dd/MM/yyyy HH:mm' }}</span>
                            </span>
                          </p>
                          <p class="flex justify-between mb-6">
                            <span class="font-semibold flex items-center">
                              <mat-icon svgIcon="heroicons_solid:map-pin" class="mr-2" />
                              Recorrido:
                            </span>
                            <span>{{ route.visitsSummary }}</span>
                          </p>
                        </div>
                  
                        <!-- Tabla de visitas -->
                        <div class="col-span-2 mb-0">
                          <table mat-table [dataSource]="dataSourceVisit" class="w-width min-w-500 overflow-y-visible mat-elevation-z" style="padding-top: 0px;" multiTemplateDataRows>
                            <ng-container matColumnDef="pin">
                              <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle w-min-p"></th>
                              <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text w-min-p">
                                <button (click)="selectVisit(innerDetail)">
                                  <mat-icon svgIcon="heroicons_outline:map-pin" class="text-primary-500"></mat-icon>
                                </button>
                              </td>
                            </ng-container>
                  
                            <ng-container matColumnDef="shipTo">
                              <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">Socio de Negocio</th>
                              <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
                                <p class="table-text-m text-uppercase">
                                  <span class="table-text-code">{{ innerDetail?.shipTo?.externalKeys?.code }}</span>
                                  <br />
                                  {{ innerDetail?.shipTo?.name }}
                                </p>
                              </td>
                            </ng-container>
                  
                            <ng-container matColumnDef="visit">
                              <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle"> Visita </th>
                              <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
                                <p class="table-text-m text-uppercase">
                                  <span class="table-text-code">{{ innerDetail?.name || 'Establecimiento Cerrado' }}</span>
                                  <br />
                                  {{ innerDetail?.serials || '-' }}
                                </p>
                              </td>
                            </ng-container>
                  
                            <ng-container matColumnDef="duration">
                              <th mat-header-cell *matHeaderCellDef class="px-6 text-center first-col table-tittle">Duración</th>
                              <td mat-cell *matCellDef="let innerDetail" class="px-6 text-center first-col table-text">{{ innerDetail.duration }}</td>
                            </ng-container>
                  
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsVisits" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsVisits;" class="table-detail-row"></tr>
                          </table>
                        </div>
                      </div>
                    </div>
                  </mat-tab>
                  
                  <mat-tab>
                    <ng-template mat-tab-label>
                      <div class="flex flex-row items-center gap-2">
                        <mat-icon
                          svgIcon="heroicons_solid:document"
                          class="w-6 h-6 text-stale-500"
                        ></mat-icon>
                        <span>Documentos</span>
                        <button
                          (click)="onDetailsDocument()"
                          class="cursor-pointer p-2 w-min h-min rounded-full bg-blue-500 text-white flex items-center justify-center shadow-md hover:bg-blue-600 transition text-xs"
                        >
                          {{  route?.statusDocument?.countDocument || 0 }}
                        </button>
                      </div>
                    </ng-template>
                     <!-- Panel de métricas -->
          <div *ngIf="isVisibleDetailsDoc" class="px-4 pt-4 bg-gray-100 rounded-lg shadow-md">
            <div class="grid grid-cols-4 gap-4">
              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <p class="text-gray-600 font-medium">
                    Cantidad de Documentos
                  </p>
                  <mat-icon matTooltip="Recargar" svgIcon="heroicons_solid:arrow-path"
                    class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                </div>
                <p class="text-2xl font-bold text-blue-500">
                  {{ route?.statusDocument?.countDocument }}
                </p>
              </div>
          
              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">No se Sincronizan</p>
                <p class="text-2xl font-bold text-purple-400">
                  {{ route?.statusDocument?.notAllowedSync }}
                </p>
              </div>
          
              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <div class="flex flex-row items-center justify-center">
                  <p class="text-gray-600 font-medium">Por Sincronizar</p>
                  <mat-icon [matMenuTriggerFor]="actionMenuSincronizar" matTooltip="Sincronizar"
                    svgIcon="heroicons_solid:arrow-path" class="w-6 h-6 text-stale-500 ml-4 cursor-pointer"></mat-icon>
                </div>
                <p class="text-2xl font-bold text-yellow-500">
                  {{
                  route?.statusDocument?.notSynchronization +
                  route?.statusDocument?.loadSynchronization
                  }}
                </p>
                <!-- Despplegable soncronizar -->
          
                <mat-menu #actionMenuSincronizar="matMenu">
                  <button mat-menu-item>
                    <mat-icon [matBadge]="
                                route?.statusDocument?.notSynchronization +
                                route?.statusDocument?.loadSynchronization
                              ">sync</mat-icon>
                    <label> Sincronizar Todo</label>
                  </button>
                  <button mat-menu-item>
                    <mat-icon [matBadge]="route?.statusDocument?.notSynchronization" svgIcon="heroicons_outline:arrow-path"></mat-icon>
                    Volver a Sincronizar
                  </button>
                  <button mat-menu-item>
                    <mat-icon [matBadge]="route?.statusDocument?.loadSynchronization" svgIcon="heroicons_outline:clock"></mat-icon>
                    Sincronizar Pendientes
                  </button>
                </mat-menu>
              </div>
          
              <div class="p-4 bg-white shadow-md rounded-lg text-center">
                <p class="text-gray-600 font-medium">Sincronizados</p>
                <p class="text-2xl font-bold text-green-500">
                  {{ route?.statusDocument?.synchronization }}
                </p>
              </div>
            </div>
          
            <div class="flex justify-end mt-4">
              <button (click)="onDetailsDocument()" class="px-8 bg-white shadow-md rounded-t-lg h-6">
                <mat-icon svgIcon="heroicons_solid:chevron-up" class="text-xs"></mat-icon>
              </button>
            </div>
          </div>
                    <table mat-table [dataSource]="route.documents" class="w-width min-w-500 overflow-y-visible mat-elevation-z" style="padding-top: 0px;"  multiTemplateDataRows >

                      <ng-container matColumnDef="expandable">
                        <th mat-header-cell *matHeaderCellDef
                        class="px-6 text-left first-col w-min-detail-b " 
                        ></th>
                        <td mat-cell *matCellDef="let element"
                        class="px-6 first-col cursor-pointer max-w-26  group-hover:bg-gray-100">
                          <!-- <button
                            mat-icon-button
                            (click)="toggleRow(element)"
                          > -->
                            <!-- <span class="mr-2 cursor-pointer" (click)="toggleRow(element)">
                              <i class="fas" [ngClass]="{'fa-chevron-down': selectedDetail?.code !== element?.code, 'fa-chevron-up': selectedDetail?.code === element?.code}"></i>
                            </span> -->
                            <button class="rounded-full p-1 hover:bg-gray-200" (click)="toggleRow(element)">
                              <i class="fas" [ngClass]="{'fa-chevron-down': selectedDetail?.id !== element?.id, 'fa-chevron-up': selectedDetail?.id === element?.id}"></i>
                            </button>
                          <!-- </button> -->
                        </td>
                      </ng-container>

                      <!-- <ng-container matColumnDef="circle">
                        <th mat-header-cell *matHeaderCellDef class="text-center first-col  w-min-detail"></th>
                        <td mat-cell *matCellDef="let element" class="text-center  first-col  w-min-detail">
        
                          <div class="circle"></div>
                  
                        </td>
                      </ng-container> -->

                      <ng-container matColumnDef="shipTo">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-left table-tittle">Socio de Negocio</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-left table-text text-uppercase" style="max-width: 105px;">
                          <!-- <div class="flex flex-row items-center">
                          <div class="circle"></div> -->
                          <p class="table-text-m text-uppercase" style="min-width: 102px;">
                            <span class="table-text-code">{{
                              element?.shipTo?.externalKeys?.code
                            }}</span
                            ><br />
                            {{ element?.shipTo?.name }}
                          </p>
                          <!-- </div>   -->
                        </td>
                      </ng-container>

                      <ng-container matColumnDef="document">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Nro. Documentos</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text">{{ element.document.countDocument }} </td>
                      </ng-container>

                      <ng-container matColumnDef="noSync">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          class="px-6 text-center table-tittle"
                        >
                          No se Sincronizan
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          class="px-6 text-center table-text"
                        >
                          {{ element?.document?.notAllowedSync }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="toSync">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          class="px-6 text-center table-tittle"
                        >
                          Por Sincronizar
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          class="px-6 text-center table-text"
                        >
                          {{
                            element?.document?.loadSynchronization +
                              element?.document?.notSynchronization
                          }}
                        </td>
                      </ng-container>
                      <ng-container matColumnDef="sync">
                        <th
                          mat-header-cell
                          *matHeaderCellDef
                          class="px-6 text-center table-tittle"
                        >
                          Sincronizados
                        </th>
                        <td
                          mat-cell
                          *matCellDef="let element"
                          class="px-6 text-center table-text"
                        >
                          {{ element?.document?.synchronization }}
                        </td>
                      </ng-container>

                      <!-- <ng-container matColumnDef="price">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Precio({{this.currency}})</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text"> {{ element.subTotal | moneda}} </td>
                      </ng-container> -->

                      <!-- <ng-container matColumnDef="loan">
                        <th mat-header-cell *matHeaderCellDef class="px-6 text-center table-tittle">Carga</th>
                        <td mat-cell *matCellDef="let element" class="px-6 text-center table-text">
                            {{element.loan | number : '1.3-3' }} {{element.weightUnitOfMeasureCode}}
                        </td>
                      </ng-container> -->

                      <ng-container matColumnDef="expanded">
                        <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                          <tr *ngIf="selectedDetail?.id === element?.id" class="details-row">
                            <td [attr.colspan]="displayedColumns.length">
                              <ng-container *ngTemplateOutlet="
                                 nestedTableTemplate;
                                  context: { $implicit: element }
                                "></ng-container>
                            </td>
                          </tr>
                        </td>
                      </ng-container>

                      <!-- Cabeceras -->

                      <tr mat-header-row *matHeaderRowDef="displayedColumns" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                      <tr mat-row *matRowDef="let element; columns: displayedColumns;"  [class.table-expanded-row]="
                        sselectedDetail?.id === element?.id
                      "></tr>

                      <!-- Filas de detalles -->
                      <tr mat-row *matRowDef="let row; columns: ['expanded']"   class="table-detail-row"></tr>
                    </table>
                  </mat-tab>
                  </mat-tab-group>
              <!-- </div> -->
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>


  <ng-template #nestedTableTemplate>
              <div class="p-1 pl-13 flex w-full flex-col ">
                <table mat-table [dataSource]="dataSourceShip" class="w-width min-w-500 overflow-y-visible mat-elevation-z"   style="padding-top: 0px;" multiTemplateDataRows >
                 
                  <ng-container matColumnDef="expandable">
                    <th mat-header-cell *matHeaderCellDef
                    class="px-6 text-left first-col w-min-p " 
                    ></th>
                    <td mat-cell *matCellDef="let innerDetail"
                    class="px-6 first-col cursor-pointer max-w-26  group-hover:bg-gray-100">
                        <button class="rounded-full p-1 hover:bg-gray-200" (click)="toggleShip(innerDetail)">
                          <i class="fas" [ngClass]="{'fa-chevron-down': selectedShip?.serial !== innerDetail?.serial, 'fa-chevron-up': selectedShip?.serial === innerDetail?.serial}"></i>
                        </button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef class=" text-left first-col table-tittle  w-min-p "></th>
                    <td mat-cell *matCellDef="let innerDetail" class=" text-left first-col table-text">
                      <mat-icon *ngIf="innerDetail.statusId == StatusEnum.INACTIVE" svgIcon="heroicons_solid:x-circle" matTooltip="Anulado" style="color:rgb(141, 19, 19); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ACTIVE" svgIcon="heroicons_solid:check-circle" matTooltip="Activo" style="color:rgb(65, 106, 218); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_IN_PROGRESS" svgIcon="heroicons_solid:play-circle" matTooltip="En progreso" style="color:rgb(236, 199, 58); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_APPROVED" svgIcon="heroicons_solid:check-circle" matTooltip="Aprobado" style="color:rgb(9, 133, 50); cursor: pointer;"></mat-icon>
                      <mat-icon *ngIf="innerDetail.statusId == StatusEnum.ORDER_REJECTED" svgIcon="heroicons_solid:x-circle" matTooltip="Rechazado" style="color:rgb(255, 0, 0); cursor: pointer;"></mat-icon>
                      <!--<mat-icon *ngIf="element.statusId == StatusEnum.ORDER_DELIVERED" svgIcon="heroicons_solid:check-circle" matTooltip="Pedido Finalizado" style="color:rgb(9, 133, 50)"></mat-icon>-->
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="statusERP">
                      <th mat-header-cell *matHeaderCellDef  class=" text-left first-col table-tittle  w-min-p "></th>
                      <td mat-cell *matCellDef="let innerDetail" class=" text-left first-col table-text">
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_PENDING || !innerDetail.statusERP" svgIcon="heroicons_solid:clock" matTooltip="Pendiente envío a ERP" style="color: rgb(233, 124, 61); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_SEND" svgIcon="heroicons_solid:document-arrow-up" matTooltip="Enviado a ERP" style="color: rgb(65, 106, 218); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_RECEIVED" svgIcon="heroicons_solid:document-arrow-down" matTooltip="Recibido por ERP" style="color: rgb(236, 199, 58); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_CREATED" svgIcon="heroicons_solid:document-check" matTooltip="Creado en ERP" style="color: rgb(9, 133, 50); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_ERROR" svgIcon="heroicons_solid:exclamation-triangle" matTooltip="Error enviando a ERP" style="color: rgb(141, 19, 19); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_PENDING_FOR_UPDATE" svgIcon="heroicons_solid:clock" matTooltip="Mod. pendiente de replicar" style="color: rgb(148, 46, 139); cursor: pointer"></mat-icon>
                        <mat-icon *ngIf="innerDetail.statusERP == OrderStatusERPEnum.ORDER_ERROR_ERP" svgIcon="heroicons_solid:exclamation-triangle" matTooltip="Error en ERP" style="color: rgb(255, 0, 0); cursor: pointer"></mat-icon>
                      </td>
                  </ng-container>
                  
                  <ng-container matColumnDef="type">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle"> Tipo Documento</th>
                    <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m text-uppercase">
                        <span class="table-text-code">{{
                          innerDetail?.type?.code
                        }}</span
                        ><br />
                        {{ innerDetail?.type?.name }}
                      </p>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="class">
                    <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle"> Clase Documento</th>
                    <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
                      <p class="table-text-m text-uppercase">
                        <span class="table-text-code">{{
                          innerDetail?.class?.code
                        }}</span
                        ><br />
                        {{ innerDetail?.class?.name }}
                      </p>
                    </td>
                  </ng-container>


                  <ng-container matColumnDef="loan">
                    <th mat-header-cell *matHeaderCellDef    class="px-6 text-right first-col table-tittle"> Peso</th>
                    <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-right first-col table-text"> {{innerDetail.loan | number : '1.3-3'}} {{innerDetail.weightUnitOfMeasureCode}}</td>
                  </ng-container>

                  <ng-container matColumnDef="price">
                    <th mat-header-cell *matHeaderCellDef    class="px-6 text-right first-col table-tittle"> Total({{this.currency}})</th>
                    <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-right first-col table-text text-uppercase">{{innerDetail.total | moneda}}</td>
                  </ng-container>

                  <ng-container matColumnDef="serial">
                    <th mat-header-cell *matHeaderCellDef    class="px-6 text-center first-col table-tittle"> Nro. Documento </th>
                    <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-center first-col table-text">{{innerDetail.serial}}</td>
                  </ng-container>


                  <ng-container matColumnDef="expanded">
                    <td mat-cell *matCellDef="let innerDetail" [attr.colspan]="displayedColumnsShip.length">
                      <tr *ngIf="selectedShip?.serial === innerDetail?.serial" class="details-row">
                        <td [attr.colspan]="displayedColumnsShip.length">
                          <ng-container *ngTemplateOutlet="
                             material;
                              context: { $implicit: innerDetail }
                            "></ng-container>
                        </td>
                      </tr>
                    </td>
                  </ng-container>

                  <!-- Cabeceras -->

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsShip" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                  <tr mat-row *matRowDef="let innerDetail; columns: displayedColumnsShip;"  [class.table-expanded-row]="
                    sselectedShip?.serial === innerDetail?.serial
                  "></tr>

                  <!-- Filas de detalles -->
                  <tr mat-row *matRowDef="let row; columns: ['expanded']"   class="table-detail-row"></tr>
              

                  <!-- <tr mat-header-row *matHeaderRowDef="displayedColumnsShip" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsShip;" class="table-detail-row"></tr> -->
                </table>
              </div>
</ng-template>


<ng-template #material>
  <div class="p-1 pl-13 flex w-full flex-col ">
    <table mat-table [dataSource]="dataSourceMaterial" class="w-width min-w-500 overflow-y-visible mat-elevation-z"   style="padding-top: 0px;" multiTemplateDataRows >
      <ng-container matColumnDef="material">
        <th mat-header-cell *matHeaderCellDef class="px-6 text-left first-col table-tittle">Material</th>
        <td mat-cell *matCellDef="let innerDetail" class="px-6 text-left first-col table-text">
          <p class="table-text-m text-uppercase">
            <span class="table-text-code">{{
              innerDetail?.material?.externalKeys?.code
            }}</span
            ><br />
            {{ innerDetail?.material?.name }}
          </p>
        </td>
      </ng-container>
      
      <ng-container matColumnDef="quantity">
        <th mat-header-cell *matHeaderCellDef    class="px-6 text-right first-col table-tittle"> Cantidad </th>
        <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-right first-col table-text">{{innerDetail.baseQuantity | number : '1.3-3'}}</td>
      </ng-container>

      <ng-container matColumnDef="loan">
        <th mat-header-cell *matHeaderCellDef    class="px-6 text-right first-col table-tittle"> Peso</th>
        <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-right first-col table-text"> {{innerDetail.loan | number : '1.3-3'}} {{innerDetail.weightUnitOfMeasureCode}} </td>
      </ng-container>

      <ng-container matColumnDef="price">
        <th mat-header-cell *matHeaderCellDef    class="px-6 text-right first-col table-tittle"> Precio({{this.currency}})</th>
        <td mat-cell *matCellDef="let innerDetail"  class="px-6 text-right first-col table-text text-uppercase"> {{innerDetail.originalUnitPrice | moneda}} </td>
      </ng-container>

  


      <tr mat-header-row *matHeaderRowDef="displayedColumnsMaterial" class="sticky top-0 z-10  bg-white dark:bg-gray-900"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumnsMaterial;" class="table-detail-row"></tr>
    </table>
  </div>
</ng-template>

  <!-- Paginador fijo abajo -->
  <div class="flex-shrink-0 bg-gray-100 dark:bg-gray-900 border-b">
    <mat-paginator
      class="z-10"
      [pageSizeOptions]="[50, 100, 150, 200]"
      showFirstLastButtons
      [length]="totalItems"
      [pageSize]="pageSize"
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</section>